module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smart_Lock.6196405c.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smart_Lock.svg
// module id = 1612
// module chunks = 0